import { BaseControl, BaseControlProps, Chip } from "@bsm/component";
import { useContractManagerQuery } from "hooks/useContractManagerQuery";
import { useTimeOffTypeList } from "../../../hooks/useTimeOffTypeList";
import { useEffect } from "react";
import { useDailyQuotaLeaveTypes } from "hooks/useDailyQuotaLeaveTypes";

export const AppointmentVacationBalance = (props: Props) => {
    const { data } = useContractManagerQuery(props.formData?.employee?.id, props?.formData?.type as any, true);
    const timeOffTypes = useTimeOffTypeList('LEAVE');
    const dailyQuotaTypes = useDailyQuotaLeaveTypes()

    const getSoldeValue = () => {
        if (!props.formData?.type || !data?.leaveBalance) {
            return (data?.leaveBalance as any)?.congeSolde?.toString() ?? '0';
        }

        if (dailyQuotaTypes.includes(props.formData?.type)) {
            return ((data?.leaveBalance as any)?.getRemainingQuota ?? 0).toString();
        } else {
            return (data?.leaveBalance as any)?.congeSolde?.toString() ?? '0';
        }
    };

    const soldeValue = getSoldeValue();

    useEffect(() => {
        if (props.value !== soldeValue) {
            props.onChange(soldeValue);
        }
    }, [data, props.formData?.type, timeOffTypes, soldeValue, props.value]);

    return (
      <BaseControl {...props}>
        <div className="bg-primary text-white font-semibold rounded px-3 py-1.5 text-center">
          {soldeValue}
        </div>
      </BaseControl>
    );
};

type Props = BaseControlProps & {
    value?: string;
    onChange: (value: Props["value"]) => void;
};
